export const speakerIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path
    d="M0.971924 7.49072V13.0532H4.28442L7.97192 16.0532V4.42822L4.28442 7.49072H0.971924Z"
    stroke="var(--zbp-svg-primary-color, white)"
    stroke-width="1.2"
    stroke-linejoin="round"/>
  <path
    d="M11.2219 5.71875L11.4339 5.96101C13.5392 8.36702 13.447 11.9856 11.2219 14.2812"
    stroke="var(--zbp-svg-primary-color, white)"
    stroke-width="1.2"
    stroke-linecap="round"/>
  <path
    d="M12.9816 2.89392L13.3334 3.29603C16.8277 7.28952 16.6747 13.2956 12.9816 17.106"
    stroke="var(--zbp-svg-primary-color, white)"
    stroke-width="1.2"
    stroke-linecap="round"/>
  <path
    d="M15.4534 1.16321L15.8909 1.66325C20.2363 6.6294 20.046 14.0983 15.4534 18.8368"
    stroke="var(--zbp-svg-primary-color, white)"
    stroke-width="1.2"
    stroke-linecap="round"/>
</svg>
`;
